<mat-progress-spinner
    mode="determinate"
    [value]="progress"
    [diameter]="200"
    [strokeWidth]="10"
></mat-progress-spinner>
